module.exports = __webpack_public_path__ + "img/green_042.c0a6dc71.png";